import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import type { TutorLessonOption } from '../../models/Tutor';
import { TutorLessonOptionContent } from './TutorLessonOptionCard';

export interface TutorLessonOptionPickerProps {
  label: string;
  options: TutorLessonOption[];
  value: string;
  onChange: (id: string) => void;
  disabled?: boolean;
  sx?: object;
}

const TutorLessonOptionPicker: React.FC<TutorLessonOptionPickerProps> = ({
  label,
  options,
  value,
  onChange,
  disabled = false,
  sx,
}) => {
  const selectable = options.filter((option) => Boolean(option.id));

  return (
    <FormControl fullWidth sx={sx} disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(String(e.target.value))}
        label={label}
        disabled={disabled}
        MenuProps={{
          PaperProps: {
            sx: { maxHeight: 360 },
          },
        }}
        sx={{
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            minHeight: '1.4375em',
          },
        }}
        renderValue={(selected) => {
          const option = selectable.find((row) => row.id === selected);
          if (!option) return null;
          return <TutorLessonOptionContent option={option} compact />;
        }}
      >
        {selectable.map((option) => (
          <MenuItem
            key={option.id}
            value={option.id as string}
            sx={{ py: 1.25, whiteSpace: 'normal', alignItems: 'flex-start' }}
          >
            <TutorLessonOptionContent option={option} hideDescription />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TutorLessonOptionPicker;
